export function Ornament({ className = "w-16 h-4 ornament" }) {
  return (
    <svg viewBox="0 0 160 24" className={className} aria-hidden>
      <path d="M8 12 H60"/>
      <circle cx="70" cy="12" r="3"/>
      <path d="M80 6 C 85 12, 85 12, 80 18"/>
      <path d="M80 6 C 75 12, 75 12, 80 18"/>
      <circle cx="90" cy="12" r="3"/>
      <path d="M100 12 H152"/>
    </svg>
  );
}

export function CornerFlourish({ className = "w-24 h-24 ornament opacity-70" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden>
      <path d="M2 2 L 40 2"/>
      <path d="M2 2 L 2 40"/>
      <path d="M2 2 C 18 6, 22 10, 24 22"/>
      <path d="M2 2 C 6 18, 10 22, 22 24"/>
      <circle cx="26" cy="26" r="2.5"/>
    </svg>
  );
}

export function Divider({ label, center = false, light = false }) {
  return (
    <div className={`flex items-center gap-2.5 py-1 ${center ? "justify-center" : ""} ${light ? "text-[color:var(--gold-2)]" : "text-[color:var(--gold)]"}`}>
      <span className="w-7 h-[2px] rounded-full bg-current"/>
      {label && <span className="text-[15px] font-semibold">{label}</span>}
      {center && <span className="w-7 h-[2px] rounded-full bg-current"/>}
    </div>
  );
}
